const iPhone14ProMaxDimensions = {
  width: 80.8,
  height: 163.4,
};

export const iphone14ProMaxTemplateFunction = (
  ctx: CanvasRenderingContext2D,
  canvaWidth: number,
  canvaHeight: number
) => {
  const multiplier = 3;
  const x = canvaWidth / 2 - (iPhone14ProMaxDimensions.width * multiplier) / 2;
  const y =
    canvaHeight / 2 - (iPhone14ProMaxDimensions.height * multiplier) / 2;

  // Scale dimensions
  const width = iPhone14ProMaxDimensions.width * multiplier;
  const height = iPhone14ProMaxDimensions.height * multiplier;
  const radius = 50;

  // --- Rounded rectangle body ---
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(
    x + width,
    y + height,
    x + width - radius,
    y + height + 150
  );
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();

  ctx.lineWidth = 4;
  ctx.strokeStyle = '#333';
  ctx.stroke();

  // --- Camera bump rectangle (rounded) ---
  // Place bump proportional to case size
  const bumpWidth = 42.2 * multiplier;
  const bumpHeight = bumpWidth;
  const bumpX = x + 5 * multiplier;
  const bumpY = y + 5 * multiplier;
  const bumpRadius = 15;

  ctx.beginPath();
  ctx.moveTo(bumpX + bumpRadius, bumpY);
  ctx.lineTo(bumpX + bumpWidth - bumpRadius, bumpY);
  ctx.quadraticCurveTo(
    bumpX + bumpWidth,
    bumpY,
    bumpX + bumpWidth,
    bumpY + bumpRadius
  );
  ctx.lineTo(bumpX + bumpWidth, bumpY + bumpHeight - bumpRadius);
  ctx.quadraticCurveTo(
    bumpX + bumpWidth,
    bumpY + bumpHeight,
    bumpX + bumpWidth - bumpRadius,
    bumpY + bumpHeight
  );
  ctx.lineTo(bumpX + bumpRadius, bumpY + bumpHeight);
  ctx.quadraticCurveTo(
    bumpX,
    bumpY + bumpHeight,
    bumpX,
    bumpY + bumpHeight - bumpRadius
  );
  ctx.lineTo(bumpX, bumpY + bumpRadius);
  ctx.quadraticCurveTo(bumpX, bumpY, bumpX + bumpRadius, bumpY);
  ctx.closePath();

  ctx.lineWidth = 3;
  ctx.strokeStyle = '#222';
  ctx.stroke();

  // --- Camera lenses (inside bump) ---
  const cameraR = bumpWidth * 0.2; // radius proportional to bump
  const cameras = [
    { cx: bumpX + bumpWidth * 0.27, cy: bumpY + bumpHeight * 0.25 },
    { cx: bumpX + bumpWidth * 0.73, cy: bumpY + bumpHeight * 0.5 },
    { cx: bumpX + bumpWidth * 0.27, cy: bumpY + bumpHeight * 0.75 },
  ];

  cameras.forEach(({ cx, cy }) => {
    ctx.beginPath();
    ctx.arc(cx, cy, cameraR, 0, Math.PI * 2, false);
    ctx.lineWidth = 3;
    ctx.strokeStyle = '#555';
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(cx, cy, cameraR * 0.7, 0, Math.PI * 2, false);
    ctx.fillStyle = '#000';
    ctx.fill();
  });

  // --- Small flash/sensor ---
  ctx.beginPath();
  ctx.arc(
    bumpX + bumpWidth * 0.73,
    bumpY + bumpHeight * 0.15,
    cameraR * 0.3,
    0,
    Math.PI * 2,
    false
  );
  ctx.fillStyle = 'black';
  ctx.fill();
};

export const iphone14ProMaxClipFunction = (
  ctx: CanvasRenderingContext2D,
  canvaWidth: number,
  canvaHeight: number
) => {
  const multiplier = 3;

  const x = canvaWidth / 2 - (iPhone14ProMaxDimensions.width * multiplier) / 2;
  const y =
    canvaHeight / 2 - (iPhone14ProMaxDimensions.height * multiplier) / 2;

  const width = iPhone14ProMaxDimensions.width * multiplier;
  const height = iPhone14ProMaxDimensions.height * multiplier;
  const radius = 35;

  // --- Outer case rounded rectangle ---
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();

  // --- Camera bump rectangle (rounded) ---
  const bumpWidth = 40.2 * multiplier;
  const bumpHeight = bumpWidth;
  const bumpX = x + 4 * multiplier;
  const bumpY = y + 3.5 * multiplier;
  const bumpRadius = 35;

  ctx.moveTo(bumpX + bumpRadius, bumpY);
  ctx.lineTo(bumpX + bumpWidth - bumpRadius, bumpY);
  ctx.quadraticCurveTo(
    bumpX + bumpWidth,
    bumpY,
    bumpX + bumpWidth,
    bumpY + bumpRadius
  );
  ctx.lineTo(bumpX + bumpWidth, bumpY + bumpHeight - bumpRadius);
  ctx.quadraticCurveTo(
    bumpX + bumpWidth,
    bumpY + bumpHeight,
    bumpX + bumpWidth - bumpRadius,
    bumpY + bumpHeight
  );
  ctx.lineTo(bumpX + bumpRadius, bumpY + bumpHeight);
  ctx.quadraticCurveTo(
    bumpX,
    bumpY + bumpHeight,
    bumpX,
    bumpY + bumpHeight - bumpRadius
  );
  ctx.lineTo(bumpX, bumpY + bumpRadius);
  ctx.quadraticCurveTo(bumpX, bumpY, bumpX + bumpRadius, bumpY);
  ctx.closePath();

  ctx.globalAlpha = 0.5; // 0 = fully transparent, 1 = fully opaque
  // ctx.fillStyle = 'rgb(255, 255, 255)'; // or any color you want
  ctx.fill();
  ctx.globalAlpha = 1; // reset alpha for next drawings

  // Use even-odd rule to clip everything outside the bump
  ctx.clip('evenodd');
};

export const iphone14ProMaxTemplate = {
  template: iphone14ProMaxTemplateFunction,
  clip: iphone14ProMaxClipFunction,
};
